<div class="container mt-1">
  <div class="row">
    <div class="col-lg-12">
      <div class="pt-2" style="background-color: white"></div>
      <div class="pt-0 pl-2 pr-1 pb-5" style="background-color: white; border-left: 1px solid black">
        <div class="row mt-2">
          <!--Imagens do produto miniatura-->
          <div class="col-xl-2 col-md-5 col-12 pr-2 mb-3">
            <!-- <div id="listaImagens" (click)="changeClientColorPhoto($event)"></div> -->
            <app-image-slider [imagens]="imagens" [visible]="4" (selectCor)="SetCorSelecionada($event)">
            </app-image-slider>
          </div>
          <!--Produto-->
          <div class="col-xl-3 col-md-7 col-12 mb-3 pr-0">
            <div *ngIf="
                corSelecionada &&
                  corSelecionada.sources &&
                  corSelecionada.sources.length;
                else elseBlockImg
              ">
              <div class="d-lg-block col-12 col-lg-12">
                <div id="carousel-imagem-produto-cor" data-ride="carousel" class="carousel slide">
                  <div class="carousel-inner">
                    <div *ngFor="let src of corSelecionada.sources" class="carousel-item {{ src.classe }}">
                      <a id="ekkoLightbox" href="{{ src.value }}" class="d-block w-100 product h-100"
                        data-toggle="lightbox" data-gallery="example-gallery" data-title=" ">
                        <img src="{{ src.value }}" class="img-fluid product-image" width="322px" height="322px" />
                      </a>
                    </div>
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carousel-imagem-produto-cor" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only" i18n>Anterior</span>
                </a>
                <a class="carousel-control-next" href="#carousel-imagem-produto-cor" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only" i18n>Próximo</span>
                </a>
              </div>
            </div>
            <ng-template #elseBlockImg>
              <div>
                <img src="assets/no-product-image.jpg" class="img-fluid" />
              </div>
            </ng-template>
            <div class="mb-1">
              <h4 class="mb-0">{{ product?.descricao }}</h4>
              <div>
                <span class="ref">Ref.: {{ product?.referencia }}</span>
              </div>
              <div *ngIf="
                  pedido &&
                    pedido.tabela &&
                    product?.tabelasPrecos &&
                    product?.tabelasPrecos[pedido.tabela.id] &&
                    product?.tabelasPrecos[pedido.tabela.id].preco;
                  else elseBlockPrecoPadrao
                ">
                <div *ngIf="
                    product?.tabelasPrecos[pedido.tabela.id].precoPromocional;
                    else elseBlockPreco
                  ">
                  <span class="moneyOff" i18n>R${{
                    product?.tabelasPrecos[pedido.tabela.id].preco
                    | currency : "BRL" : ""
                    }}</span>
                  <span class="money1 ml-1" i18n>R${{
                    product?.tabelasPrecos[pedido.tabela.id].precoPromocional
                    | currency : "BRL" : ""
                    }}</span>
                </div>
                <ng-template #elseBlockPreco>
                  <span class="money" i18n>R${{ preco | currency : "BRL" : "" }}</span>
                </ng-template>
                <div *ngIf="mostraLabelImposto; else elseBlockImposto">
                  <div *ngFor="let item of ufsImpostosMap | keyvalue">
                    <div class="moneyImposto" i18n>
                      + R${{ item.value | currency : "BRL" : "" }} -
                      {{ item.key }}
                    </div>
                  </div>
                </div>
                <ng-template #elseBlockImposto>
                  <div *ngIf="
                      this.SITE.mostraImpostoDetalhado &&
                      !this.SITE.mostraprecosemimposto
                    " class="div-produto-imposto">
                    <div *ngFor="let imposto of ufsImpostosMap[ufSelected]">
                      <div class="moneyImposto" *ngIf="imposto.valor" i18n>
                        {{ imposto.tipo }}: + R${{
                        imposto.valor | currency : "BRL" : ""
                        }}
                      </div>
                    </div>
                    <div i18n class="money" *ngIf="
                        ufsImpostosMap[ufSelected] &&
                        this.SITE.mostraprecosemimposto
                      ">
                      Total: R${{ valorTotal | currency : "BRL" : "" }}
                    </div>
                  </div>
                </ng-template>
              </div>
              <ng-template #elseBlockPrecoPadrao>
                <div *ngIf="
                    tabelaPadrao &&
                    product?.tabelasPrecos &&
                    product?.tabelasPrecos[tabelaPadrao] &&
                    product?.tabelasPrecos[tabelaPadrao].preco &&
                    mostraPreco
                  ">
                  <div *ngIf="
                      product?.tabelasPrecos[tabelaPadrao].precoPromocional;
                      else elseBlockPreco2
                    ">
                    <span class="moneyOff" i18n>R${{
                      product?.tabelasPrecos[tabelaPadrao].preco
                      | currency : "BRL" : ""
                      }}</span>
                    <span class="money1 ml-1" i18n>R${{
                      product?.tabelasPrecos[tabelaPadrao].precoPromocional
                      | currency : "BRL" : ""
                      }}</span>
                  </div>
                  <ng-template #elseBlockPreco2>
                    <!-- Preço -->
                    <span class="money" i18n>R${{
                      product?.tabelasPrecos[tabelaPadrao].preco
                      | currency : "BRL" : ""
                      }}</span>
                  </ng-template>
                </div>
              </ng-template>
            </div>
            <div class="mt-2 observacao-resumo" style="font-size: 0.8rem">
              <div *ngIf="
                  product?.observacoes &&
                    product?.observacoes.length > descr1Limit;
                  else elseBlockObs2
                " class="mb-4">
                <div class="obsproduto1 mb-3" style="white-space: pre-wrap">
                  <div class="collapse mb-1" id="collapseObs2" aria-expanded="false">
                    <simple-html [whiteSpace]="descr1WhiteSpace" [html]="product?.observacoes">
                    </simple-html>
                  </div>
                  <a role="button" class="collapsed mt-2 btn btn-outline-secondary btn-sm" data-toggle="collapse"
                    href="#collapseObs2" aria-expanded="false" aria-controls="collapseObs2"></a>
                </div>
              </div>
              <ng-template #elseBlockObs2>
                <div class="mb-4" style="white-space: pre-wrap">
                  {{ product?.observacoes }}
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Modo Visualizacao 1 -->
          <div *ngIf="this.modoVisualizacaoPageProduto == 1" class="col-xl-7 col-12 mt-2">
            <div *ngIf="this.descontoPorItem == 1 && descontoMax > 0 && pedido" i18n>
              Desconto (%):
            </div>
            <div *ngIf="this.descontoPorItem == 1 && descontoMax > 0 && pedido">
              <input [(ngModel)]="descontoPercent" class="form-control col-3 mb-2" />
            </div>
            <div *ngIf="
                pedido &&
                pedido.tabela &&
                pedido.filial &&
                product?.ativo &&
                product?.tabelasPrecos[pedido.tabela.id] &&
                product?.tabelasPrecos[pedido.tabela.id].preco > 0
              " class="grade mb-2">
              <div style="overflow: auto" class="mb-2">
                <div class="float-right">
                  <button (click)="limparGrade()" class="btn btn-sm btn-outline-secondary btn-limpa-grade"
                    style="font-size: 0.8rem !important" i18n>
                    Limpar grade
                  </button>
                </div>
                <div *ngIf="corSelecionada" class="float-right pr-4 cor-selecionada" style="margin-top: 5px">
                  <label style="font-size: 0.8rem" i18n>Cor selecionada:</label>
                  {{ corSelecionada.descricao }}
                </div>
              </div>
              <form *ngIf="corSelecionada" (ngSubmit)="onSubmit()" [formGroup]="form" [style.overflow-x]="'scroll'">
                <div *ngFor="let est of estampas" class="grade-item">
                  <div class="text-center mb-1 grade-item-estampa" style="border-top: 1px solid #dee2e6" i18n>
                    Estampa: {{ est.codigo }} - {{ est.descricao }}
                  </div>
                  <table class="table table-hover table-sm table-striped mb-2">
                    <tr class="grade-item-tamanho">
                      <th class="identificacao-cliente"></th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        {{ tam.tamanho }}
                      </th>
                    </tr>
                    <tbody>
                      <tr *ngFor="let cli of clientes">
                        <td class="identificacao-cliente">
                          <app-show-details [cli]="cli"
                            [identificacaoCliente]="SITE.identificacaoCliente"></app-show-details>
                        </td>
                        <td *ngFor="let tam of tamanhos">
                          <div *ngVar="
                              corSelecionada.cor +
                              '@' +
                              est.id +
                              '@' +
                              tam.tamanho +
                              '@' +
                              cli.id as IDFIELD
                            ">
                            <!-- Verifica se há estoque -->
                            <div class="quantity-wrapper">
                              <!-- bloco principal -->
                              <div class="input-group quantity-group" *ngIf="
                                  formQuantidade[
                                    corSelecionada.cor +
                                      '@' +
                                      est.id +
                                      '@' +
                                      tam.tamanho
                                  ] > 0 ||
                                    form.get(IDFIELD)?.value >= 1 ||
                                    !pedido.tipo.validaEstoque;
                                  else semEstoque
                                ">
                                <a class="noselect quantity-button quantity-button-minus" (click)="decrement(IDFIELD)">
                                  –
                                </a>

                                <div class="quantity-input-box">
                                  <input type="number" min="0" step="{{ multiplo }}" formControlName="{{ IDFIELD }}"
                                    name="{{ IDFIELD }}" class="form-control quantity-input"
                                    (input)="changeToZero(IDFIELD, { tam, est }, corSelecionada)" />
                                </div>

                                <a class="noselect quantity-button quantity-button-plus" (click)="increment(IDFIELD)">
                                  +
                                </a>
                              </div>

                              <!-- bloco alternativo -->
                              <ng-template #semEstoque>
                                <div class="input-group quantity-group" style="min-width: 50px">
                                  <button *ngIf="produtoDetalhe.aviso.visible" class="btn quantity-btn-aviso"
                                    type="button" (click)="throwError()">
                                    Avise
                                  </button>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <!-- Linha de estoque -->
                    <tr *ngIf="SITE.mostraEstoqueDigitacao">
                      <th i18n>ESTOQUE</th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            formQuantidade[
                              corSelecionada.cor +
                                '@' +
                                est.id +
                                '@' +
                                tam.tamanho
                            ] as QUANT
                          ">
                          {{
                          this.SITE.quantidadeMaximaGrade > 0 &&
                          QUANT >= this.SITE.quantidadeMaximaGrade
                          ? this.SITE.quantidadeMaximaGrade + "+"
                          : QUANT
                          }}
                        </div>
                      </th>
                    </tr>

                    <tr class="quantidade-minima-row" *ngIf="SITE.mostraEstoqueDigitacao">
                      <th i18n>QTD MINIMA</th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div>
                          {{ getQtdMin(tam.tamanho, corSelecionada.cor) }}
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="
                        pedido.tipo.precoDivergente && mostraPrecoMinimoVenda
                      ">
                      <td i18n>R$ MÍNIMO</td>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'min' +
                            corSelecionada.cor +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center">
                            <div class="form-group mb-0 text-center" style="color: orange">
                              {{ precosDivergentes[IDFIELD] }}
                            </div>
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="pedido.tipo.precoDivergente" class="preco-venda">
                      <td i18n>R$ VENDA</td>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'ideal' +
                            corSelecionada.cor +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center moneyVerde" style="font-size: 0.8rem">
                            {{ precosDivergentes[IDFIELD] }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="pedido.tipo.precoDivergente" class="preco-venda">
                      <th></th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'precoDiv@' +
                            corSelecionada.cor +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center">
                            <input type="text" formControlName="{{ IDFIELD }}" name="{{ IDFIELD }}" maxlength="14"
                              onkeyup="mask(this, money);" onkeydown="mask(this, money);" autocomplete="off"
                              class="form-control precoMoney" style="font-weight: bold; color: blue" [class.errorForm]="
                                error && form.get(IDFIELD).invalid
                              " />
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <div *ngIf="error" class="alert alert-primary" role="alert">
                  {{ errorMsg }}
                </div>

                <div class="text-right mt-4">
                  <button i18n class="btn btn-primary">
                    Adicionar ao carrinho
                  </button>
                </div>
                <div class="mt-2 observacao-resumo-responsive" style="font-size: 0.8rem">
                  <div *ngIf="
                      product?.observacoes &&
                        product?.observacoes.length > descr1Limit;
                      else elseBlockObs2
                    " class="mb-4">
                    <div class="obsproduto1 mb-3" style="white-space: pre-wrap">
                      <div class="collapse mb-1" id="collapseObs2" aria-expanded="false">
                        <simple-html [whiteSpace]="descr1WhiteSpace" [html]="product?.observacoes">
                        </simple-html>
                      </div>
                      <a role="button" class="collapsed mt-2 btn btn-outline-secondary btn-sm" data-toggle="collapse"
                        href="#collapseObs2" aria-expanded="false" aria-controls="collapseObs2"></a>
                    </div>
                  </div>
                  <ng-template #elseBlockObs2>
                    <div class="mb-4" style="white-space: pre-wrap">
                      {{ product?.observacoes }}
                    </div>
                  </ng-template>
                </div>
              </form>
            </div>
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" data-toggle="tab" href="#nav-descricao" role="tab"
                  aria-controls="nav-descricao" aria-selected="true" i18n>
                  Descrição
                </a>

                <a class="nav-item nav-link" *ngIf="
                    product?.fichaTecnica && product?.fichaTecnica.length > 0
                  " data-toggle="tab" href="#nav-ficha" role="tab" aria-controls="nav-ficha" aria-selected="false"
                  i18n>
                  Ficha Técnica
                </a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-aplicacao" role="tab"
                  aria-controls="nav-aplicacao" aria-selected="false" *ngIf="produtoAplicacaoContent" i18n>
                  Aplicação
                </a>

                <a class="nav-item nav-link" data-toggle="tab" href="#nav-crossreference" role="tab"
                  aria-controls="nav-crossreference" aria-selected="false" *ngIf="produtoCrossreferenceContent">
                  Cross Reference
                </a>
                <a *ngIf="securityService.hasToken()" class="nav-item nav-link aba-detalhes" data-toggle="tab"
                  href="#nav-detalhes" role="tab" aria-controls="nav-detalhes" aria-selected="false" i18n>
                  Detalhes
                </a>

                <a class="nav-item nav-link" data-toggle="tab" href="#nav-imagens" role="tab"
                  aria-controls="nav-imagens" aria-selected="false" i18n>
                  Imagens
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active p-1" [style.margin-top]="descr2MarginTop + 'px'" id="nav-descricao"
                role="tabpanel" aria-labelledby="navDescricao">
                <div *ngIf="
                    product?.observacoesSite &&
                      product?.observacoesSite.length > descr2Limit;
                    else elseBlockObs
                  " style="overflow-x: auto" class="mb-4">
                  <div class="obsproduto2 mb-3 pl-1">
                    <div class="collapse mb-1" id="collapseObs" aria-expanded="false">
                      <simple-html [whiteSpace]="descr2WhiteSpace" [html]="product?.observacoesSite">
                      </simple-html>
                    </div>
                    <a role="button" id="btn-collapsed" class="collapsed mt-2 btn btn-outline-secondary btn-sm"
                      data-toggle="collapse" href="#collapseObs" aria-expanded="false" aria-controls="collapseObs"></a>
                  </div>
                </div>
                <ng-template #elseBlockObs>
                  <div class="mb-4">
                    <simple-html [whiteSpace]="descr2WhiteSpace" [html]="product?.observacoesSite">
                    </simple-html>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="securityService.hasToken()" class="tab-pane fade p-1 mt-3" id="nav-detalhes" role="tabpanel"
                aria-labelledby="navDetalhes">
                <div *ngIf="SITE.mostraEstoqueDigitacao" class="grade">
                  <table class="table table-sm" style="margin-bottom: 10px">
                    <thead>
                      <tr>
                        <th style="font-size: inherit">Estoque</th>
                      </tr>
                    </thead>
                  </table>
                  <div *ngFor="let fil of filiaisEstoqueDetalhe" style="border-top: 1px solid #dee2e6" class="mb-3">
                    <div class="mb-1 grade-item-estampa float-left">
                      {{ fil.titulo }}
                    </div>
                    <div *ngFor="let est of product?.estampas">
                      <div class="text-center mb-1 grade-item-estampa float-right">
                        Estampa: {{ est.codigo }} - {{ est.descricao }}
                      </div>
                      <table class="table table-hover table-sm table-striped mb-2">
                        <tr>
                          <th></th>
                          <th *ngFor="let tam of product?.tamanhos" style="text-align: center">
                            {{ tam.tamanho }}
                          </th>
                        </tr>
                        <tbody>
                          <tr *ngFor="let cor of product?.cores">
                            <td>{{ cor.codigo }} - {{ cor.descricao }}</td>
                            <td *ngFor="let tam of tamanhos" class="text-center">
                              {{
                              getEstoqueSimpleString(
                              cor.id,
                              est.id,
                              tam.tamanho,
                              fil.id
                              )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div *ngIf="!SITE.mostraEstoqueDigitacao" class="row">
                  <div class="col-sm-6 mb-2">
                    <div *ngIf="product?.cores" class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th>Cores</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let cor of product?.cores">
                            <td>{{ cor.descricao }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="product?.estampas" class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th i18n>Estampas</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let e of product?.estampas">
                            <td>{{ e.descricao }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div *ngIf="product?.tamanhos" class="table-responsive">
                      <table class="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th i18n>Tamanhos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let tam of product?.tamanhos">
                            <td>{{ tam.tamanho }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade p-1 mt-3" id="nav-imagens" role="tabpanel" aria-labelledby="navImagens">
                <div *ngIf="product?.imagens.length > 0" class="row">
                  <ng-container *ngFor="let img of product?.imagens; let i = index">
                    <div *ngIf="img.cor == corSelecionada.cor" class="col-sm-3 mb-3">
                      <div class="card text-white {{
                          i == 0 ? 'bg-primary' : 'bg-secondary'
                        }}">
                        <div class="card-body">
                          <a id="ekkoLightbox" [href]="API_IMAGENS_PRODUTOS + img.nome" data-toggle="lightbox"
                            data-title=" " data-gallery="example-gallery">
                            <img [src]="API_IMAGENS_PRODUTOS + img.nome" class="img-fluid" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="
                  product?.fichaTecnica && product?.fichaTecnica.length > 0
                " class="tab-pane fade p-1 mt-3" id="nav-ficha">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr *ngFor="let item of product?.fichaTecnica">
                        <td>
                          <b>{{ item.key }}</b>
                        </td>
                        <td><simple-html [html]="item.value"></simple-html></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="produtoAplicacaoContent" class="tab-pane fade p-1 mt-3" id="nav-aplicacao">
                <div [innerHTML]="produtoAplicacaoContent"></div>
              </div>
              <div *ngIf="produtoCrossreferenceContent" class="tab-pane fade p-1 mt-3" id="nav-crossreference">
                <div [innerHTML]="produtoCrossreferenceContent"></div>
              </div>
            </div>
            <a *ngIf="!this.securityService.hasToken()" routerLink="/login" role="button" id="btn-entrar" i18n
              class="mt-2 ml-2 btn btn-outline-secondary btn-sm">
              Entrar
            </a>
          </div>

          <!-- Modo Visualizacao 2 -->
          <div *ngIf="this.modoVisualizacaoPageProduto == 2" class="col mt-2">
            <div *ngIf="this.descontoPorItem == 1" i18n>Desconto (%):</div>
            <div *ngIf="this.descontoPorItem == 1">
              <input [(ngModel)]="descontoPercent" class="form-control col-3 mb-2" />
            </div>
            <div *ngIf="
                pedido &&
                pedido.tabela &&
                pedido.filial &&
                product?.ativo &&
                product?.tabelasPrecos[pedido.tabela.id] &&
                product?.tabelasPrecos[pedido.tabela.id].preco > 0
              " class="grade mb-2">
              <div style="overflow: auto" class="mb-2">
                <div class="float-right">
                  <button (click)="limparGrade()" class="btn btn-sm btn-outline-secondary"
                    style="font-size: 0.8rem !important" i18n>
                    Limpar grade
                  </button>
                </div>
                <div *ngIf="clienteSelecionado" class="float-right pr-4" style="margin-top: 5px">
                  <label i18n style="font-size: 0.8rem">Cliente selecionado:</label>
                  {{ clienteSelecionado.nome }}
                </div>
              </div>
              <form *ngIf="clienteSelecionado" (ngSubmit)="onSubmit()" [formGroup]="form">
                <div *ngFor="let est of estampas" class="grade-item">
                  <div class="text-center mb-1 grade-item-estampa" style="border-top: 1px solid #dee2e6" i18n>
                    Estampa: {{ est.codigo }} - {{ est.descricao }}
                  </div>

                  <!-- estampas -->
                  <table class="table table-hover table-sm table-striped mb-2" style="border: 1px solid #dee2e6">
                    <tr style="text-align: center; vertical-align: middle">
                      <th i18n>Imagens</th>
                      <th i18n>Cor</th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        {{ tam.tamanho }}
                      </th>
                    </tr>
                    <tbody>
                      <ng-container *ngFor="let cor of cores">
                        <!-- Primeira linha de cada cor -->
                        <tr>
                          <td rowspan="2" style="
                              text-align: center;
                              vertical-align: middle;
                              border-right: 1px solid #dee2e6;
                            ">
                            <div *ngFor="let img of imagens">
                              <a *ngIf="img.cor == cor.id" (click)="SetCorSelecionada(cor)" style="cursor: pointer">
                                <img *ngIf="img.cor == cor.id" src="{{ img.src.value }}" alt="{{ img.descricao }}"
                                  style="
                                    height: 80px;
                                    cursor: pointer;
                                    border-radius: 10px;
                                    border: 3px solid white;
                                    object-fit: contain;
                                    object-position: center;
                                  " />
                              </a>
                            </div>
                          </td>
                          <td style="text-align: center; vertical-align: middle">
                            <a (click)="SetCorSelecionada(cor)" style="
                                cursor: pointer;
                                text-decoration-line: underline;
                              ">{{ cor.descricao }}</a>
                          </td>
                          <td *ngFor="let tam of tamanhos" style="text-align: center; vertical-align: middle">
                            <div *ngVar="
                                cor.id +
                                '@' +
                                est.id +
                                '@' +
                                tam.tamanho +
                                '@' +
                                clienteSelecionado.id as IDFIELD
                              ">
                              <div class="form-group mb-0 text-center">
                                {{ clienteSelecionado.id }}
                                <input type="number" min="0" step="{{ multiplo }}" formControlName="{{ IDFIELD }}"
                                  name="{{ IDFIELD }}" [class.errorForm]="
                                    error && form.get(IDFIELD).invalid
                                  " class="form-control" />
                              </div>
                            </div>
                          </td>
                        </tr>
                        <!-- Segunda linha de cada cor -->
                        <tr *ngIf="true || SITE.mostraEstoqueDigitacao" style="
                            /* Background with nice contrast to the black text */
                            border-top: 1px solid #dee2e6;
                            border-radius: 0 0 10px 10px;
                          ">
                          <th i18n style="text-align: center; vertical-align: middle">
                            ESTOQUE
                          </th>
                          <th *ngFor="let tam of tamanhos" style="text-align: center; vertical-align: middle">
                            <div *ngVar="
                                formQuantidade[
                                  cor.id + '@' + est.id + '@' + tam.tamanho
                                ] as QUANT
                              ">
                              {{
                              getEstoqueSimpleString(
                              cor.id,
                              est.id,
                              tam.tamanho,
                              filiaisEstoqueDetalhe[0]?.id ?? filiais[0]?.id
                              )
                              }}
                            </div>
                          </th>
                        </tr>
                      </ng-container>
                    </tbody>
                    <tr *ngIf="pedido.tipo.precoDivergente">
                      <td i18n>R$ MÍNIMO</td>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'min' +
                            corSelecionada.cor +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center">
                            <div class="form-group mb-0 text-center" style="color: orange">
                              {{ precosDivergentes[IDFIELD] }}
                            </div>
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="pedido.tipo.precoDivergente">
                      <td i18n>R$ VENDA</td>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'ideal' +
                            clienteSelecionado.id +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center moneyVerde" style="font-size: 0.8rem">
                            {{ precosDivergentes[IDFIELD] }}
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr *ngIf="pedido.tipo.precoDivergente">
                      <th></th>
                      <th *ngFor="let tam of tamanhos" style="text-align: center">
                        <div *ngVar="
                            'precoDiv@' +
                            clienteSelecionado.id +
                            '@' +
                            est.id +
                            '@' +
                            tam.tamanho as IDFIELD
                          ">
                          <div class="form-group mb-0 text-center">
                            <input type="text" formControlName="{{ IDFIELD }}" name="{{ IDFIELD }}" maxlength="14"
                              onkeyup="mask(this, money);" onkeydown="mask(this, money);" autocomplete="off"
                              class="form-control precoMoney" style="font-weight: bold; color: blue" [class.errorForm]="
                                error && form.get(IDFIELD).invalid
                              " />
                          </div>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <div *ngIf="error" class="alert alert-primary" role="alert">
                  {{ errorMsg }}
                </div>

                <div class="text-right mt-4">
                  <button class="btn btn-primary" i18n>
                    Adicionar ao carrinho
                  </button>
                </div>
              </form>
            </div>
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" data-toggle="tab" href="#nav-descricao" role="tab"
                  aria-controls="nav-descricao" aria-selected="true" i18n>
                  Descrição
                </a>

                <a class="nav-item nav-link" *ngIf="
                    product?.fichaTecnica && product?.fichaTecnica.length > 0
                  " data-toggle="tab" href="#nav-ficha" role="tab" aria-controls="nav-ficha" aria-selected="false"
                  i18n>
                  Ficha Técnica
                </a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-aplicacao" role="tab"
                  aria-controls="nav-aplicacao" aria-selected="false" *ngIf="produtoAplicacaoContent" i18n>
                  Aplicação
                </a>

                <a class="nav-item nav-link" data-toggle="tab" href="#nav-crossreference" role="tab"
                  aria-controls="nav-crossreference" aria-selected="false" *ngIf="produtoCrossreferenceContent">
                  Cross Reference
                </a>
                <a *ngIf="securityService.hasToken()" class="nav-item nav-link aba-detalhes" data-toggle="tab"
                  href="#nav-detalhes" role="tab" aria-controls="nav-detalhes" aria-selected="false" i18n>
                  Detalhes
                </a>

                <a class="nav-item nav-link" data-toggle="tab" href="#nav-imagens" role="tab"
                  aria-controls="nav-imagens" aria-selected="false" i18n>
                  Imagens
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active p-1" [style.margin-top]="descr2MarginTop + 'px'" id="nav-descricao"
                role="tabpanel" aria-labelledby="navDescricao">
                <div *ngIf="
                    product?.observacoesSite &&
                      product?.observacoesSite.length > descr2Limit;
                    else elseBlockObs
                  " style="overflow-x: auto" class="mb-4">
                  <div class="obsproduto2 mb-3 pl-1">
                    <div class="collapse mb-1" id="collapseObs" aria-expanded="false">
                      <simple-html [whiteSpace]="descr2WhiteSpace" [html]="product?.observacoesSite">
                        <slider-produto (redirectTo)="redirectTo.emit($event)" [values]="productsFeatured"
                          [title]="titleSliderProdutos" [dots]="dotsSliderProdutos" [infinite]="infiniteSliderProdutos"
                          [interval]="intervalSliderProdutos"></slider-produto>
                      </simple-html>
                    </div>
                    <a role="button" id="btn-collapsed" class="collapsed mt-2 btn btn-outline-secondary btn-sm"
                      data-toggle="collapse" href="#collapseObs" aria-expanded="false" aria-controls="collapseObs"></a>
                  </div>
                </div>
                <ng-template #elseBlockObs>
                  <div class="mb-4">
                    <simple-html [whiteSpace]="descr2WhiteSpace" [html]="product?.observacoesSite">
                    </simple-html>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="securityService.hasToken()" class="tab-pane fade p-1 mt-3" id="nav-detalhes" role="tabpanel"
                aria-labelledby="navDetalhes">
                <div *ngIf="SITE.mostraEstoqueDigitacao" class="grade">
                  <table class="table table-sm" style="margin-bottom: 10px">
                    <thead>
                      <tr>
                        <th i18n style="font-size: inherit">Estoque</th>
                      </tr>
                    </thead>
                  </table>
                  <div *ngFor="let fil of filiaisEstoqueDetalhe" style="border-top: 1px solid #dee2e6" class="mb-3">
                    <div class="mb-1 grade-item-estampa float-left">
                      {{ fil.titulo }}
                    </div>
                    <div *ngFor="let est of product?.estampas">
                      <div i18n class="text-center mb-1 grade-item-estampa float-right">
                        Estampa: {{ est.codigo }} - {{ est.descricao }}
                      </div>
                      <table class="table table-hover table-sm table-striped mb-2">
                        <div class="col-lg-1 col-4 pl-2 pr-2 mb-3">
                          <div id="listaImagens" (click)="changeClientColorPhoto($event)"></div>
                        </div>
                        <tr>
                          <th></th>
                          <th *ngFor="let tam of product?.tamanhos" style="text-align: center">
                            {{ tam.tamanho }}
                          </th>
                        </tr>
                        <tbody>
                          <tr *ngFor="let cor of product?.cores">
                            <td>{{ cor.codigo }} - {{ cor.descricao }}</td>
                            <td *ngFor="let tam of tamanhos" class="text-center">
                              {{
                              getEstoqueSimpleString(
                              cor.id,
                              est.id,
                              tam.tamanho,
                              fil.id
                              )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div *ngIf="!SITE.mostraEstoqueDigitacao" class="row">
                  <div class="col-sm-6 mb-2">
                    <div *ngIf="product?.cores" class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th i18n>Cores</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let cor of product?.cores">
                            <td>{{ cor.descricao }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="product?.estampas" class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th i18n>Estampas</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let e of product?.estampas">
                            <td>{{ e.descricao }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div *ngIf="product?.tamanhos" class="table-responsive">
                      <table class="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th i18n>Tamanhos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let tam of product?.tamanhos">
                            <td>{{ tam.tamanho }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade p-1 mt-3" id="nav-imagens" role="tabpanel" aria-labelledby="navImagens">
                <div *ngIf="product?.imagens.length > 0" class="row">
                  <div *ngFor="let img of product?.imagens; let i = index" class="col-sm-3 mb-3">
                    <div class="card text-white {{
                        i == 0 ? 'bg-primary' : 'bg-secondary'
                      }}">
                      <div class="card-body">
                        <a id="ekkoLightbox" href="{{ API_IMAGENS_PRODUTOS }}{{ img.nome }}" data-toggle="lightbox"
                          data-gallery="example-gallery" data-title=" ">
                          <img src="{{ API_IMAGENS_PRODUTOS }}{{ img.nome }}" class="img-fluid" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="
                  product?.fichaTecnica && product?.fichaTecnica.length > 0
                " class="tab-pane fade p-1 mt-3" id="nav-ficha">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr *ngFor="let item of product?.fichaTecnica">
                        <td>
                          <b>{{ item.key }}</b>
                        </td>
                        <td>{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="produtoAplicacaoContent" class="tab-pane fade p-1 mt-3" id="nav-aplicacao">
                <div [innerHTML]="produtoAplicacaoContent"></div>
              </div>
              <div *ngIf="produtoCrossreferenceContent" class="tab-pane fade p-1 mt-3" id="nav-crossreference">
                <div [innerHTML]="produtoCrossreferenceContent"></div>
              </div>
            </div>
            <a *ngIf="!this.securityService.hasToken()" routerLink="/login" role="button" id="btn-entrar"
              class="mt-2 ml-2 btn btn-outline-secondary btn-sm" i18n>
              Entrar
            </a>
          </div>

          <div id="slider-rec" class="col-12 col-md-12 col-lg-12">
            <slider-produto (redirectTo)="redirectTo.emit($event)" [autoplay]="false" [values]="produtosRelacionado"
              [title]="'Produtos Relacionados'"></slider-produto>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- 
<div class="modal-dialog" id="productDetailsModalDialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <img src=""
    </div>
  </div>
</div> -->

<div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja abandonar digitação?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="canDeactivateObs.next(true)" type="button" data-dismiss="modal"
          class="btn btn-outline-primary">
          Ok
        </button>
        <button type="canDeactivateObs.next(false)" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<script>
  window.onbeforeunload = function () {
    var scrollPos;
    if (typeof window.pageYOffset != "undefined") {
      scrollPos = window.pageYOffset;
    } else if (
      typeof document.compatMode != "undefined" &&
      document.compatMode != "BackCompat"
    ) {
      scrollPos = document.documentElement.scrollTop;
    } else if (typeof document.body != "undefined") {
      scrollPos = document.body.scrollTop;
    }
    document.cookie = "scrollTop=" + scrollPos;
  };
  window.onload = function () {
    if (document.cookie.match(/scrollTop=([^;]+)(;|$)/) != null) {
      var arr = document.cookie.match(/scrollTop=([^;]+)(;|$)/);
      document.documentElement.scrollTop = parseInt(arr[1]);
      document.body.scrollTop = parseInt(arr[1]);
    }
  };
</script>